import { atom } from 'jotai'
import { type DynamicField, type Group } from '../../../types/beRecipientsApi'
import { type Tag } from '../../../types/beListApi'
import { type GeoCountry } from '../types'

export const allGroupsAtom = atom<Group[]>([])

export const dynamicFieldsAtom = atom<DynamicField[]>([])

export const tagsAtom = atom<Tag[]>([])
export const countriesAtom = atom<GeoCountry[]>([])

export const countriesLoadingAtom = atom<boolean>(false)
export const regionsLoadingAtom = atom<boolean>(false)
